import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  public title = signal('Healthy Contracts');

  setTitle(newTitle: string) {
    this.title.set(newTitle);
  }
}